import type { UseQueryResult } from '@tanstack/react-query';

import type { JobCluster } from '~/shared/data-contract/job-cluster';

import { useFamiliesWithClustersQuery } from './use-families-with-clusters';

const selectClustersForFamily =
    (jobFamilyId: string) =>
    (families: readonly { readonly id: string; readonly clusters: readonly JobCluster[] }[]): readonly JobCluster[] =>
        families.find((family) => family.id === jobFamilyId)?.clusters ?? [];

export const useJobClusters = (
    jobArchitectureId: string,
    jobFamilyId: string,
    options?: { readonly enabled?: boolean },
): UseQueryResult<readonly JobCluster[], Error> =>
    useFamiliesWithClustersQuery(jobArchitectureId, {
        enabled: options?.enabled,
        select: selectClustersForFamily(jobFamilyId),
    });

export const useIsJobClusterGenerating = (
    jobArchitectureId: string,
    jobFamilyId: string,
    jobClusterId: string,
): boolean => {
    const { data: jobClusters } = useJobClusters(jobArchitectureId, jobFamilyId);

    return (
        jobClusters?.some(
            (jobCluster) => jobCluster.id === jobClusterId && jobCluster.generationInfo?.inProgress === true,
        ) ?? false
    );
};
